module.exports = __webpack_public_path__ + "media/images/hold-icon-40848bf91887728d5be9aaa6ce71df3f.svg";